import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GstProvider, useGst } from './context/GstContext';
import { AuthGuard } from './components/AuthGuard';
import { GlobalHeader } from './components/GlobalHeader';
import { GstProfileModal } from './components/GstProfileModal';
import { ScopedAiCopilotDrawer } from './components/ScopedAiCopilotDrawer';
import { SecurityTrustModal } from './components/SecurityTrustModal';
import { DataPurgeModal } from './components/DataPurgeModal';
import { LegalGateModal } from './components/LegalGateModal';

// Pillar 1: Tax Returns & Compliance Suite
import { UploadVaultPage } from './pages/UploadVaultPage';
import { LedgerPage } from './pages/LedgerPage';
import { ReconciliationPage } from './pages/ReconciliationPage';
import { ReturnsPage } from './pages/ReturnsPage';

// Pillar 2: Merchant Billing & Everyday Invoicing Suite
import { InvoiceListPage } from './pages/billing/InvoiceListPage';
import { CreateInvoicePage } from './pages/billing/CreateInvoicePage';
import { TemplatesPage } from './pages/billing/TemplatesPage';
import { ComplianceHubPage } from './pages/billing/ComplianceHubPage';

// Pillar 3: Multi-Client Practice Management (admin@verveailabs.com)
import { PracticeManagementPage } from './pages/practice/PracticeManagementPage';

import { ToastContainer, ConfirmDialogContainer } from './components/ui';

function AppContent() {
  const {
    securityModalOpen,
    setSecurityModalOpen,
    purgeModalOpen,
    setPurgeModalOpen,
    legalGateOpen,
    setLegalGateOpen
  } = useGst();

  return (
    <div className="min-h-screen bg-[#0b0c0e] text-[#f7f7f8] flex flex-col font-sans selection:bg-cyan-500/20 selection:text-cyan-200">
      <GlobalHeader />
      <main className="flex-1">
        <Routes>
          {/* Default Route */}
          <Route path="/" element={<Navigate to="/vault" replace />} />

          {/* Pillar 1: Tax Returns & Compliance Suite */}
          <Route path="/vault" element={<UploadVaultPage />} />
          <Route path="/ledger" element={<LedgerPage />} />
          <Route path="/reconciliation" element={<ReconciliationPage />} />
          <Route path="/returns" element={<ReturnsPage />} />

          {/* Pillar 2: Merchant Billing & Everyday Invoicing Suite */}
          <Route path="/billing" element={<InvoiceListPage />} />
          <Route path="/billing/create" element={<CreateInvoicePage />} />
          <Route path="/billing/templates" element={<TemplatesPage />} />
          <Route path="/billing/compliance" element={<ComplianceHubPage />} />

          {/* Pillar 3: Multi-Client Practice Management (admin@verveailabs.com) */}
          <Route path="/practice" element={<PracticeManagementPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/vault" replace />} />
        </Routes>
      </main>
      <GstProfileModal />
      <ScopedAiCopilotDrawer />
      <SecurityTrustModal
        isOpen={securityModalOpen}
        onClose={() => setSecurityModalOpen(false)}
        onOpenPurge={() => setPurgeModalOpen(true)}
      />
      <DataPurgeModal
        isOpen={purgeModalOpen}
        onClose={() => setPurgeModalOpen(false)}
      />
      <LegalGateModal
        isOpen={legalGateOpen}
        onAccept={() => setLegalGateOpen(false)}
      />
      <ToastContainer />
      <ConfirmDialogContainer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <GstProvider>
        <AuthGuard>
          <AppContent />
        </AuthGuard>
      </GstProvider>
    </BrowserRouter>
  );
}
